import React, {useEffect, useState} from 'react';
import {Chip} from '@material-ui/core';
import {Icon} from '@iconify/react';

const talentTierConfig = {
  untiered: {
    label: 'No Tier',
    icon: <Icon icon="ic:baseline-hourglass-empty" />,
    color: 'primary',
  },
  nano: {
    label: 'Nano',
    icon: <Icon icon="ic:baseline-star-border" />,
    color: 'primary',
  },
  micro: {
    label: 'Micro',
    icon: <Icon icon="ic:baseline-person" />,
    color: 'primary',
  },
  mid: {
    label: 'Mid',
    icon: <Icon icon="ic:baseline-groups" />,
    color: 'primary',
  },
  macro: {
    label: 'Macro',
    icon: <Icon icon="ic:baseline-trending-up" />,
    color: 'primary',
  },
  mega: {
    label: 'Mega',
    icon: <Icon icon="ic:baseline-public" />,
    color: 'primary',
  },
  celebrity: {
    label: 'Celebrity',
    icon: <Icon icon="ic:baseline-verified" />,
    color: 'primary',
  },
};

interface TalentTierChipProps {
  tier: string;
  size?: 'small' | 'medium';
  noIcon?: boolean;
}

export default function TalentTierChip({
  tier,
  size = 'medium',
  noIcon = false,
}: TalentTierChipProps) {
  const config =
    talentTierConfig[tier as keyof typeof talentTierConfig] ?? talentTierConfig.untiered;

  const [showIcon, setShowIcon] = useState(true);

  useEffect(() => {
    setShowIcon(!noIcon);
  }, [noIcon]);

  return (
    <Chip
      label={config.label}
      variant={'outlined'}
      style={{
        color: config.color,
        borderColor: config.color,
        padding: '0 .3rem 0 .5rem',
      }}
      icon={showIcon ? config.icon : undefined}
      size={size}
    />
  );
}
